module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agentlist"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("代理管理")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700"
    }
  }, [_vm._v("搜索代理商")]), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "350px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入ID"
    },
    model: {
      value: (_vm.searchlist.agency_id),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "agency_id", $$v)
      },
      expression: "searchlist.agency_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "350px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入微信昵称"
    },
    model: {
      value: (_vm.searchlist.nick_name),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "nick_name", $$v)
      },
      expression: "searchlist.nick_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "350px",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.searchlist.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "phone_number", $$v)
      },
      expression: "searchlist.phone_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.searchbtn
    }
  }, [_vm._v("搜索")])], 1)]), _vm._v(" "), (_vm.userlist) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信头像")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("平台来源")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("来源app")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("等级设置")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("操作")])], 1), _vm._v(" "), _vm._l((_vm.userlist), function(user) {
    return _c('div', {
      key: user,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "min-height": "60px",
        "padding": "5px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(user.nick_name))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_c('img', {
      attrs: {
        "src": user.avatar_url,
        "height": "56"
      }
    })]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(user.phone_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.platform_name[user.user_from_platform]))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.app_name[user.user_from_app]))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_c('a-select', {
      staticStyle: {
        "min-width": "100px"
      },
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (user.level),
        callback: function($$v) {
          _vm.$set(user, "level", $$v)
        },
        expression: "user.level"
      }
    }, [_c('a-select-option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("皇冠会员")]), _vm._v(" "), _c('a-select-option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("钻石会员")])], 1)], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_c('div', [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "primary",
        "disabled": !user.level,
        "ghost": ""
      },
      on: {
        "click": function($event) {
          return _vm.addagent(user)
        }
      }
    }, [_vm._v("加入代理")])], 1)])], 1)], 1)
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-container"
  }, [_c('a-tabs', {
    attrs: {
      "defaultActiveKey": _vm.liststatus,
      "activeKey": _vm.liststatus,
      "type": "card",
      "tabBarGutter": 5
    },
    on: {
      "change": function (activeKey) {
        this$1.startpage = 0;
        this$1.endpage = 10;
        this$1.pageSize = 10;
        this$1.liststatus = activeKey;
        this$1.$router.push({
          name: 'agentlist',
          query: {
            pageSize: this$1.pageSize,
            startpage: this$1.startpage,
            endpage: this$1.endpage,
            liststatus: this$1.liststatus,
            searchlist: JSON.stringify(this$1.searchlist)
          }
        });
        this$1.initialize();
      }
    }
  }, [_c('a-tab-pane', {
    key: 1,
    attrs: {
      "tab": "皇冠会员"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.agentlist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.agentlist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信头像")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("等级")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("平台来源")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("来源app")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.agentlist), function(agent) {
    return _c('div', {
      key: agent,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "min-height": "60px",
        "padding": "5px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(agent.nick_name))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_c('img', {
      attrs: {
        "src": agent.UIC_User.avatar_url,
        "height": "56"
      }
    })]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(agent.phone_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.status[agent.level]))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.platform_name[agent.user_from_platform]))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.app_name[agent.user_from_app]))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 10
      }
    }, [_c('div', [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "primary",
        "ghost": ""
      },
      on: {
        "click": function($event) {
          return _vm.toinfo(agent.id)
        }
      }
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "primary",
        "ghost": ""
      },
      on: {
        "click": function($event) {
          return _vm.searchlowerlevel(agent)
        }
      }
    }, [_vm._v("查询下级")]), _vm._v(" "), _c('a-upload', {
      attrs: {
        "name": "excelfile",
        "showUploadList": false,
        "data": {
          id: agent.id
        },
        "multiple": false,
        "action": "/upload/excel",
        "headers": "authorization-text",
        "beforeUpload": _vm.beforeUpload
      },
      on: {
        "change": _vm.daoru
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "primary",
        "ghost": "",
        "loading": _vm.loading,
        "disabled": _vm.loading
      }
    }, [_vm._v("导入订单")])], 1), _vm._v(" "), _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "danger",
        "ghost": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteagent(agent)
        }
      }
    }, [_vm._v("删除")])], 1)])], 1), _vm._v(" "), _vm._l((agent.lowerlevelinfo), function(loweinfo) {
      return (agent.lowerlevel == 2) ? _c('a-row', {
        key: loweinfo,
        staticStyle: {
          "border": "#e8e8e8 solid 1px",
          "border-top": "none",
          "min-height": "60px",
          "padding": "5px 0",
          "background-color": "#ffe9a0"
        },
        attrs: {
          "type": "flex",
          "justify": "space-around",
          "align": "middle"
        }
      }, [_c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(loweinfo.nick_name))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_c('img', {
        attrs: {
          "src": loweinfo.UIC_User.avatar_url,
          "height": "56"
        }
      })]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 3
        }
      }, [_vm._v(_vm._s(loweinfo.phone_number))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(_vm.status[loweinfo.level]))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(_vm.platform_name[loweinfo.user_from_platform]))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 2
        }
      }, [_vm._v(_vm._s(_vm.app_name[loweinfo.user_from_app]))]), _vm._v(" "), _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": !loweinfo.reviewed ? 4 : 10
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(loweinfo.reviewed ? '已审核' : '未审核') + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (!loweinfo.reviewed) ? _c('a-col', {
        staticStyle: {
          "text-align": "center"
        },
        attrs: {
          "span": 6
        }
      }, [_c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "size": "small",
          "type": "primary",
          "ghost": ""
        },
        on: {
          "click": function($event) {
            return _vm.passloweinfo(loweinfo)
          }
        }
      }, [_vm._v("通过")]), _vm._v(" "), _c('a-button', {
        staticStyle: {
          "width": "96px",
          "font-size": "12px"
        },
        attrs: {
          "size": "small",
          "type": "danger",
          "ghost": ""
        },
        on: {
          "click": function($event) {
            return _vm.denyloweinfo(loweinfo)
          }
        }
      }, [_vm._v("拒绝")])], 1) : _vm._e()], 1) : _vm._e()
    }), _vm._v(" "), (agent.lowerlevel == 1) ? _c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "min-height": "60px",
        "padding": "5px 0",
        "background-color": "#ffe9a0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v("查无下级")])], 1) : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.agentsum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])]), _vm._v(" "), _c('a-tab-pane', {
    key: 2,
    attrs: {
      "tab": "钻石会员"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', [(_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "margin-bottom": "20px",
      "padding": "30px 50px",
      "margin": "20px 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.agentlist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.agentlist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信头像")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("等级")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("平台来源")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("来源app")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("上级")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 9
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.agentlist), function(agent) {
    return _c('div', {
      key: agent,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "min-height": "60px",
        "padding": "5px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(agent.nick_name))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_c('img', {
      attrs: {
        "src": agent.UIC_User.avatar_url,
        "height": "56"
      }
    })]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(agent.phone_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.status[agent.level]))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.platform_name[agent.user_from_platform]))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.app_name[agent.user_from_app]))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(agent.superior_id !== 0 ? agent.superior_id : '无'))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 9
      }
    }, [_c('div', [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "primary",
        "ghost": ""
      },
      on: {
        "click": function($event) {
          return _vm.toinfo(agent.id)
        }
      }
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('a-upload', {
      attrs: {
        "name": "excelfile",
        "showUploadList": false,
        "data": {
          id: agent.id
        },
        "multiple": false,
        "action": "/upload/excel",
        "headers": "authorization-text",
        "beforeUpload": _vm.beforeUpload
      },
      on: {
        "change": _vm.daoru
      }
    }, [_c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "primary",
        "ghost": "",
        "loading": _vm.loading,
        "disabled": _vm.loading
      }
    }, [_vm._v("导入订单")])], 1), _vm._v(" "), _c('a-button', {
      staticStyle: {
        "width": "96px",
        "font-size": "12px"
      },
      attrs: {
        "size": "small",
        "type": "danger",
        "ghost": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteagent(agent)
        }
      }
    }, [_vm._v("删除")])], 1)])], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.agentsum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])])], 1)], 1)]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8674d8a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/agentmanagement/agentlist/index.vue
// module id = 2393
// module chunks = 1